import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import { Fade } from "@mui/material";
import mixpanel from "mixpanel-browser";
import { useLocation } from "react-router-dom";

import { auth } from "_firebase";

import { actions } from "store/users";
import { initForm, resetForm, resetFormErrors } from "store/form/actions";

import { useStateSelector } from "utils/field";
import { required, maxLength, personName, companyName } from "utils/fieldValidation";

import Dialog from "components/Dialog";
import Button from "components/Button";
import Input from "components/Input";
import InputRow from "components/Input/Row";
import Field from "components/Field";
import ModalFullScreen from "components/ModalFullScreen";
import ActionRedirect from "features/ActionRedirect";

import classes from "./style.module.scss";

import Logo from "assets/images/logo-color.svg";

const { addUserTestingInfo } = actions;

const charLim32 = maxLength(32);
const charLim200 = maxLength(200);
const charLim500 = maxLength(200);

const Transition = React.forwardRef((props, ref) => <Fade ref={ref} {...props} />);

// newForm.userTestingInfo

const ConfirmEmail = () => {
    const [isTimerActive, setIsTimerActive] = useState(false);
    const [timer, setTimer] = useState(60);

    useEffect(() => {
        let interval = null;

        if (isTimerActive && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        }

        if (timer === 0) {
            setIsTimerActive(false);
            clearInterval(interval);
        }

        return () => clearInterval(interval);
    }, [isTimerActive, timer]);

    const handleResend = async () => {
        try {
            // Resend logic here
            await auth.currentUser.sendEmailVerification();
            setIsTimerActive(true);
            setTimer(60);
        } catch (error) {
            console.error("Error resending email verification", error);
        }
    };

    return (
        <div className={classes.confirmEmailContainer}>
            <h2>We've sent you a confirmation email.</h2>
            <p>Please confirm your email address to continue.</p>
            <Button onClick={handleResend} disabled={isTimerActive}>
                Resend Email
            </Button>
            <div className={classes.timer}>{isTimerActive ? `You can resend in ${timer}s` : ""}</div>
        </div>
    );
};

const Info = ({ uid, isOpen = false, invalid, initialValues = {} }) => {
    const dispatch = useDispatch();
    const { pathname = "" } = useLocation();

    const [step, changeStep] = useState(1);

    const { isEmailConfirmed = false } = useStateSelector("user");
    const {
        firstName = "",
        lastName = "",
        company = "",
        role = "",
        experienceLevel = "",
    } = useStateSelector("newForm.userTestingInfo") || {};
    const { formErrors = [] } = useStateSelector("newForm") || {};

    useEffect(() => {
        dispatch(initForm("userTestingInfo", initialValues));

        return () => {
            dispatch(resetForm("userTestingInfo"));
        };
    }, []);

    return (
        <ModalFullScreen
            open={isOpen}
            classes={{
                paperClass: classes.paper,
            }}
            TransitionComponent={Transition}
        >
            {pathname !== "/action-redirect" ? (
                <>
                    <div className={classes.testingWrapper}>
                        <img className={classes.logo} src={Logo} alt="Volta SNAP" />
                        <SwitchTransition mode="out-in">
                            <CSSTransition
                                key={step}
                                classNames={{
                                    enter: classes.contentEnter,
                                    enterActive: classes.contentEnterActive,
                                    exit: classes.contentExit,
                                    exitActive: classes.contentExitActive,
                                }}
                                timeout={300}
                            >
                                <div className={classes.userTesting}>
                                    <ConfirmEmail />
                                </div>
                            </CSSTransition>
                        </SwitchTransition>
                    </div>
                </>
            ) : (
                <ActionRedirect />
            )}
        </ModalFullScreen>
    );
};

const mapStateToProps = ({
    user: {
        uid,
        name = "",
        isEmailConfirmed = false,
        registrationComplete = true,
        userMeta: { company = "", role = "", experienceLevel = "", agreedToTerms = false } = {},
    },
}) => {
    return {
        uid,
        isOpen: registrationComplete !== false && !isEmailConfirmed,
    };
};

export default connect(mapStateToProps, null)(Info);
